import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/cn'

export function Spinner({ className }: { className?: string }) {
  return (
    <div className="flex items-center justify-center py-12">
      <Loader2
        className={cn('size-6 animate-spin text-ink-faint', className)}
      />
    </div>
  )
}
